import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import SharedGPAto100 from "./SharedGPAto100";
import Shared100toGPA from "./Shared100toGPA";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
import GPAPlanner from "./SharedGPAPlanner";
const TITLE = "Kalkulator IPK Skala 4 - Kalkulator IPK Universitas";
const DESCRIPTION =
  "Hitung IPK mata kuliah universitas dengan mudah menggunakan kalkulator IPK universitas. Pelajari cara menghitung IPK skala 4 dengan cepat dan akurat.";
const KEYWORDS =
  "hitung IPK, kalkulator IPK universitas, hitung IPK skala 4, hitung IPK universitas";
const OG_URL = "https://do-calculate.com/calculator/id/gpa4";
function GPA4() {
  const [courses, setCourses] = useState([
    { name: "Matematika", credits: "3", grade: "A" },
    { name: "Fisika", credits: "2", grade: "B+" },
    { name: "Komputer", credits: "3", grade: "A-" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [gpa, setGPA] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);
  const [priorSemesterGPA, setPriorSemesterGPA] = useState(0);
  const [priorSemesterCreditsCompleted, setPriorSemesterCreditsCompleted] =
    useState(0);
  const gradeOptions = [
    "A+",
    "A",
    "A-",
    "B+",
    "B",
    "C+",
    "C",
    "D+",
    "D",
    "D-",
    "F",
  ];
  const addCourse = () => {
    setCourses([...courses, { name: "", credits: "", grade: "A+" }]);
  };
  const removeCourse = (index) => {
    const updatedCourses = [...courses];
    updatedCourses.splice(index, 1);
    setCourses(updatedCourses);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedCourses = [...courses];
    updatedCourses[index][name] = value;
    setCourses(updatedCourses);
  };
  const calculate = () => {
    setIsLoading(true);
    setError(null);
    let totalGradePoints = 0;
    let creditsSum = 0;
    for (const course of courses) {
      const credits = parseFloat(course.credits);
      const grade = course.grade;
      if (!isNaN(credits)) {
        const gradePoints = calculateGradePoints(grade);
        if (!isNaN(gradePoints)) {
          totalGradePoints += credits * gradePoints;
          creditsSum += credits;
        }
      }
    }
    if (creditsSum === 0) {
      setError("Masukkan nilai yang valid");
    } else {
      const calculatedGPA = totalGradePoints / creditsSum;
      setGPA(calculatedGPA.toFixed(2));
      setTotalCredits(creditsSum);
    }
    const priorSemesterGPAValue = parseFloat(priorSemesterGPA);
    const priorSemesterCreditsCompletedValue = parseFloat(
      priorSemesterCreditsCompleted
    );
    if (
      !isNaN(priorSemesterGPAValue) &&
      !isNaN(priorSemesterCreditsCompletedValue)
    ) {
      const cumulativeCredits = priorSemesterCreditsCompletedValue + creditsSum;
      const cumulativeGradePoints =
        priorSemesterGPAValue * priorSemesterCreditsCompletedValue +
        totalGradePoints;
      const cumulativeGPA = cumulativeGradePoints / cumulativeCredits;
      setGPA(cumulativeGPA.toFixed(2));
      setTotalCredits(cumulativeCredits);
    }
    setIsLoading(false);
  };
  const calculateGradePoints = (grade) => {
    let gradePoints;
    const gradeMap = {
      "A+": 4.0,
      A: 4.0,
      "A-": 3.7,
      "B+": 3.3,
      B: 3.0,
      "B-": 2.7,
      "C+": 2.3,
      C: 2.0,
      "C-": 1.7,
      "D+": 1.3,
      D: 1.0,
      "D-": 0.7,
      F: 0.0,
    };
    if (grade === "F") {
      gradePoints = 0;
    } else {
      gradePoints = gradeMap[grade] || NaN;
    }
    return gradePoints;
  };
  const calculateLetterGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "A+";
    } else if (gpa >= 3.7) {
      return "A";
    } else if (gpa >= 3.3) {
      return "A-";
    } else if (gpa >= 3.0) {
      return "B+";
    } else if (gpa >= 2.7) {
      return "B";
    } else if (gpa >= 2.3) {
      return "B-";
    } else if (gpa >= 2.0) {
      return "C+";
    } else if (gpa >= 1.7) {
      return "C";
    } else if (gpa >= 1.3) {
      return "C-";
    } else if (gpa >= 1.0) {
      return "D+";
    } else if (gpa >= 0.7) {
      return "D";
    } else {
      return "F";
    }
  };
  const calculateNumericalGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "97–100";
    } else if (gpa >= 3.7) {
      return "94–96";
    } else if (gpa >= 3.3) {
      return "90–93";
    } else if (gpa >= 3.0) {
      return "87–89";
    } else if (gpa >= 2.7) {
      return "84–86";
    } else if (gpa >= 2.3) {
      return "80–83";
    } else if (gpa >= 2.0) {
      return "77–79";
    } else if (gpa >= 1.7) {
      return "74–76";
    } else if (gpa >= 1.3) {
      return "67–69";
    } else if (gpa >= 1.0) {
      return "64–66";
    } else if (gpa >= 0.7) {
      return "60–63";
    } else {
      return "0–59";
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <p>
                  Hitung IPK skala 4 dengan mudah menggunakan kalkulator IPK universitas yang dirancang untuk membantu Anda mengetahui hasil dengan akurat dan cepat. Alat ini memungkinkan Anda memasukkan mata kuliah, jumlah SKS untuk setiap mata kuliah, dan memilih nilai yang sesuai, lalu secara otomatis menghitung IPK (GPA) berdasarkan sistem 4.0 yang digunakan di banyak universitas.
                </p>

                <p>
                  Baik Anda ingin menghitung IPK satu semester atau menghitung IPK kumulatif total dengan menambahkan IPK sebelumnya dan jumlah SKS yang telah diselesaikan, Anda dapat menggunakan kalkulator ini untuk mengetahui hasil sebenarnya tanpa kesalahan perhitungan. Anda juga dapat mengetahui nilai huruf yang sesuai dengan IPK seperti A atau B+ serta persentase perkiraan yang setara.
                </p>

                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Hitung IPK Skala 4
                  </h2>
                </div>
                <hr />
                <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                  IPK Semester Sebelumnya (Opsional):
                </div>
                <div
                  className="form-group"
                  style={{ display: "flex", marginBottom: "10px" }}
                >
                  <label htmlFor="priorGPA" style={{ width: "170px" }}>
                    IPK Sebelumnya
                  </label>
                  <input
                    type="number"
                    id="priorGPA"
                    value={priorSemesterGPA}
                    onChange={(e) => setPriorSemesterGPA(e.target.value)}
                    className="form-control"
                    style={{ width: "90%" }}
                  />
                </div>
                <div className="form-group" style={{ display: "flex" }}>
                  <label htmlFor="priorCredits" style={{ width: "170px" }}>
                    SKS yang Diselesaikan
                  </label>
                  <input
                    type="number"
                    id="priorCredits"
                    value={priorSemesterCreditsCompleted}
                    onChange={(e) =>
                      setPriorSemesterCreditsCompleted(e.target.value)
                    }
                    className="form-control"
                    style={{ width: "90%" }}
                  />
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="course">Mata Kuliah (Opsional)</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="credits">SKS</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      {" "}
                      <label htmlFor="grade">Nilai</label>
                    </b>
                  </div>
                </div>
                {courses.map((course, index) => (
                  <div
                    key={index}
                    className="form-group d-flex align-items-center"
                    style={{ marginBottom: "10px" }}
                  >
                    <input
                      type="text"
                      name="name"
                      id="course"
                      placeholder="Mata Kuliah"
                      value={course.name}
                      style={{ width: "100%" }}
                      className="form-control ml-2"
                      onChange={(e) => handleInputChange(index, e)}
                    />
                    <input
                      type="number"
                      name="credits"
                      id="credits"
                      placeholder="3"
                      value={course.credits}
                      className="form-control ml-2"
                      style={{ width: "100%" }}
                      onChange={(e) => handleInputChange(index, e)}
                    />
                    <select
                      name="grade"
                      id="grade"
                      value={course.grade}
                      className="form-control ml-2"
                      style={{ width: "100%" }}
                      onChange={(e) => handleInputChange(index, e)}
                    >
                      {gradeOptions.map((option, gradeIndex) => (
                        <option key={gradeIndex} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    <button
                      className="text-white btn bg-secondary"
                      style={{ marginRight: "2px" }}
                      onClick={() => removeCourse(index)}
                    >
                      Hapus
                    </button>
                    <br />
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addCourse}
                >
                  Tambah Mata Kuliah
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculate}
                  disabled={isLoading}
                >
                  Hitung
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <br />
              {error && (
                <div className="alert alert-warning">
                  <b>
                    <u> Terjadi Kesalahan :</u>
                  </b>{" "}
                  Harap isi semua kolom dengan benar.{" "}
                </div>
              )}
              {gpa > 0 && (
                <div
                  style={{ fontSize: "19px" }}
                  className=" bg-light bg-gradient text-dark"
                >
                  <div className=" p-3   bg-success bg-gradient text-white">
                    <strong>Hasil</strong>
                  </div>
                  <div>
                    <table >
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td className="gpa-header">IPK Kumulatif</td>
                          <td>{gpa}</td>
                        </tr>
                         <tr>
                          <td className="gpa-header">Total SKS</td>
                           <td>{totalCredits}</td>
                         </tr>
                         <tr>
                          <td className="gpa-header">Nilai Huruf</td>
                           <td>{calculateLetterGrade(gpa)}</td>
                         </tr>
                         <tr>
                          <td className="gpa-header">Nilai Numerik</td>
                           <td> {calculateNumericalGrade(gpa)}</td>
                         </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <GPAPlanner />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPAto100 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <Shared100toGPA />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Cara Menghitung IPK Skala 4
                    </h2>{" "}
                  </u>
                  <p>
                    Untuk menghitung IPK, bagi total poin nilai yang diperoleh dengan total SKS mata kuliah yang memiliki nilai huruf yang Anda ambil. Untuk setiap SKS, poin berikut diperoleh:
                  </p>
                  <ul>
                    <li>A+ = 4</li>
                    <li>A = 4</li>
                    <li>A- = 3.7</li>
                    <li>B+ = 3.3</li>
                    <li>B = 3</li>
                    <li>B- = 2.7</li>
                    <li>C+ = 2.3</li>
                    <li>C = 2</li>
                    <li>C- = 1.7</li>
                    <li>D+ = 1.3</li>
                    <li>D = 1</li>
                    <li>D- = 0.7</li>
                    <li>F = 0</li>
                  </ul>
                  <p>
                    Untuk menghitung total poin nilai pada catatan akademik Anda, kalikan poin nilai untuk setiap nilai yang diperoleh dengan jumlah SKS dalam mata kuliah (konsultasikan panduan perguruan tinggi Anda mengenai mata kuliah yang diulang dan nilai yang tidak selesai).
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GPA4;